import { useEffect, useState } from 'react';

const DEFAULT_ZOOM = 14;

type UseZoomButtonsReturn = {
  currentZoom: number;
  zoombuttonColor15: string;
  zoombuttonColor18: string;
  zoombuttonColor20: string;
  handleOnZoomChange: (zoom: number) => void;
};

export const useZoomButtons = (): UseZoomButtonsReturn => {
  const [currentZoom, setCurrentZoom] = useState<number>(DEFAULT_ZOOM);
  const [zoombuttonColor15, setZoombuttonColor15] = useState<string>('u-bg-white');
  const [zoombuttonColor18, setZoombuttonColor18] = useState<string>('u-bg-white');
  const [zoombuttonColor20, setZoombuttonColor20] = useState<string>('u-bg-white');

  useEffect(() => {
    const colorMap: Record<number, [string, string, string]> = {
      15: ['gray', 'u-bg-white', 'u-bg-white'],
      18: ['u-bg-white', 'gray', 'u-bg-white'],
      20: ['u-bg-white', 'u-bg-white', 'gray'],
    };
    const [c15, c18, c20] = colorMap[currentZoom] ?? ['u-bg-white', 'u-bg-white', 'u-bg-white'];
    setZoombuttonColor15(c15);
    setZoombuttonColor18(c18);
    setZoombuttonColor20(c20);
  }, [currentZoom]);

  const handleOnZoomChange = (zoom: number) => {
    setCurrentZoom(zoom);
  };

  return { currentZoom, zoombuttonColor15, zoombuttonColor18, zoombuttonColor20, handleOnZoomChange };
};
